import { Alert, AlertColor, SxProps, Theme } from '@mui/material';
import { FC } from 'react';

const COMPACT_SX: SxProps<Theme> = {
  py: 0,
  minHeight: 0,
  alignItems: 'center',
  '& .MuiAlert-message': { py: '0.4rem' },
  '& .MuiAlert-icon': { py: 0 },
};

interface Props {
  className?: string;
  sx?: SxProps<Theme>;
  severity?: AlertColor;
  //A single slim line, for an alert sitting inline next to a control.
  compact?: boolean;
  //E.g. a button at the end of the alert that resolves it.
  action?: React.ReactNode;
  children: React.ReactNode;
  onClose?: () => void;
}

const QcsAlert: FC<Props> = ({ className, sx, severity, compact, action, children, onClose }) => {
  return (
    <Alert
      className={className}
      sx={[{ width: 'fit-content' }, compact ? COMPACT_SX : {}, ...(Array.isArray(sx) ? sx : [sx])]}
      severity={severity}
      onClose={onClose}
      action={action}
    >
      {children}
    </Alert>
  );
};

export default QcsAlert;
